var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "8px 14px"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('set') + " " + _vm.$Jed.firstUpperTranslate('preference', 2)))]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#conn",
      "aria-controls": "conn",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('connection')))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "background-color": "white",
      "border-top": "none"
    }
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "conn"
    }
  }, [(_vm.disabled.useProxy != true) ? _c('input-w', {
    attrs: {
      "configs": {
        "id": "useProxyCheck"
      }
    },
    model: {
      value: (_vm.preferences.useProxy),
      callback: function($$v) {
        _vm.preferences.useProxy = $$v
      },
      expression: "preferences.useProxy"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.useProxy),
      expression: "preferences.useProxy"
    }],
    attrs: {
      "id": "useProxy",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.preferences.useProxy) ? _vm._i(_vm.preferences.useProxy, null) > -1 : (_vm.preferences.useProxy)
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        var $$a = _vm.preferences.useProxy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.preferences.useProxy = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.preferences.useProxy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.preferences.useProxy = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useProxy"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('use proxy')))])]) : _vm._e(), _vm._v(" "), (_vm.preferences.useProxy) ? _c('div', {
    staticClass: "margin-son"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "3px"
    }
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "addresProxyText"
      }
    },
    model: {
      value: (_vm.preferences.addressProxy),
      callback: function($$v) {
        _vm.preferences.addressProxy = $$v
      },
      expression: "preferences.addressProxy"
    }
  }, [_c('label', {
    staticClass: "col-xs-4 col-md-3 sublabel",
    attrs: {
      "for": "addressProxy"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('proxy address')))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.addressProxy),
      expression: "preferences.addressProxy"
    }],
    attrs: {
      "id": "addressProxy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.preferences.addressProxy)
    },
    on: {
      "change": _vm.contentChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preferences.addressProxy = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "portProxyText"
      }
    },
    model: {
      value: (_vm.preferences.portProxy),
      callback: function($$v) {
        _vm.preferences.portProxy = $$v
      },
      expression: "preferences.portProxy"
    }
  }, [_c('label', {
    staticClass: "col-xs-4 col-md-3 sublabel",
    attrs: {
      "for": "portProxy"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('proxy port')))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.portProxy),
      expression: "preferences.portProxy"
    }],
    attrs: {
      "id": "portProxy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.preferences.portProxy)
    },
    on: {
      "change": _vm.contentChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preferences.portProxy = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), (_vm.preferences.addressProxy && _vm.preferences.addressProxy != '') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-4 col-md-3 sublabel"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-9",
    staticStyle: {
      "color": "#888",
      "margin-top": "3px"
    }
  }, [_vm._v(_vm._s(_vm.getURL()))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": {
        "id": "useOfflineCheck"
      }
    },
    model: {
      value: (_vm.preferences.useOffline),
      callback: function($$v) {
        _vm.preferences.useOffline = $$v
      },
      expression: "preferences.useOffline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.useOffline),
      expression: "preferences.useOffline"
    }],
    attrs: {
      "id": "useOffline",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.preferences.useOffline) ? _vm._i(_vm.preferences.useOffline, null) > -1 : (_vm.preferences.useOffline)
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        var $$a = _vm.preferences.useOffline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.preferences.useOffline = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.preferences.useOffline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.preferences.useOffline = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useOffline"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("offline use (no connection)")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("offline use explanation")))])]), _vm._v(" "), (_vm.preferences.useOffline) ? _c('div', {
    staticClass: "margin-son"
  }, [_c('div', {
    staticClass: "radio-title"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("storage")))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("storage explanation")))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "margin-self"
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "persistenceRadio"
      }
    },
    model: {
      value: (_vm.preferences.persistence),
      callback: function($$v) {
        _vm.preferences.persistence = $$v
      },
      expression: "preferences.persistence"
    }
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.persistence),
      expression: "preferences.persistence"
    }],
    attrs: {
      "name": "pers",
      "type": "radio",
      "id": "auto",
      "value": "Auto"
    },
    domProps: {
      "checked": _vm._q(_vm.preferences.persistence, "Auto")
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        _vm.preferences.persistence = "Auto"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("automatic")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("automatic explanation")))])]), _vm._v(" "), (_vm.preferences.persistence == 'Auto') ? _c('div', {
    staticClass: "margin-son"
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "docCatCheck"
      }
    },
    model: {
      value: (_vm.preferences.docCat),
      callback: function($$v) {
        _vm.preferences.docCat = $$v
      },
      expression: "preferences.docCat"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.docCat),
      expression: "preferences.docCat"
    }],
    attrs: {
      "id": "docCat",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.preferences.docCat) ? _vm._i(_vm.preferences.docCat, null) > -1 : (_vm.preferences.docCat)
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        var $$a = _vm.preferences.docCat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.preferences.docCat = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.preferences.docCat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.preferences.docCat = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "docCat"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("all drawings")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("all drawings explanation")) + " ")])]), _vm._v(" "), (_vm.preferences.docCat) ? _c('div', {
    staticClass: "margin-son"
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "docProdCheck"
      }
    },
    model: {
      value: (_vm.preferences.docProd),
      callback: function($$v) {
        _vm.preferences.docProd = $$v
      },
      expression: "preferences.docProd"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.docProd),
      expression: "preferences.docProd"
    }],
    attrs: {
      "id": "docProd",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.preferences.docProd) ? _vm._i(_vm.preferences.docProd, null) > -1 : (_vm.preferences.docProd)
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        var $$a = _vm.preferences.docProd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.preferences.docProd = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.preferences.docProd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.preferences.docProd = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "docProd"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("all attachments")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("all attachments explanation")))])]), _vm._v(" "), (_vm.preferences.docProd) ? _c('div', {
    staticClass: "margin-self"
  }, [_c('div', {
    staticClass: "radio-title"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("attachments language")))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("attachments language explanation")))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": {
        "id": "everyLang"
      }
    },
    model: {
      value: (_vm.everyLang),
      callback: function($$v) {
        _vm.everyLang = $$v
      },
      expression: "everyLang"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.everyLang),
      expression: "everyLang"
    }],
    attrs: {
      "id": "everyLang",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.everyLang) ? _vm._i(_vm.everyLang, null) > -1 : (_vm.everyLang)
    },
    on: {
      "change": _vm.everyLangOneBindChange,
      "__c": function($event) {
        var $$a = _vm.everyLang,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.everyLang = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.everyLang = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.everyLang = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "everyLang"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("all")))])]), _vm._v(" "), _vm._l((_vm.languages), function(l) {
    return _c('input-w', {
      key: l.COD,
      attrs: {
        "configs": {
          "id": "everyLang" + l.COD
        }
      },
      model: {
        value: (_vm.preferences.docProdLang[l.COD]),
        callback: function($$v) {
          _vm.$set(_vm.preferences.docProdLang, l.COD, $$v)
        },
        expression: "preferences.docProdLang[l.COD]"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences.docProdLang[l.COD]),
        expression: "preferences.docProdLang[l.COD]"
      }],
      attrs: {
        "id": 'everyLang' + l.COD,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.preferences.docProdLang[l.COD]) ? _vm._i(_vm.preferences.docProdLang[l.COD], null) > -1 : (_vm.preferences.docProdLang[l.COD])
      },
      on: {
        "change": _vm.langChange,
        "__c": function($event) {
          var $$a = _vm.preferences.docProdLang[l.COD],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences.docProdLang[l.COD] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences.docProdLang[l.COD] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.preferences.docProdLang, l.COD, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'everyLang' + l.COD
      }
    }, [_vm._v(_vm._s(l.description))])])
  })], 2) : _vm._e()], 1) : _vm._e()], 1) : _c('br'), _vm._v(" "), (_vm.disabled.persistence_Manual != true) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.persistence),
      expression: "preferences.persistence"
    }],
    attrs: {
      "name": "pers",
      "type": "radio",
      "id": "man",
      "value": "Manual"
    },
    domProps: {
      "checked": _vm._q(_vm.preferences.persistence, "Manual")
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        _vm.preferences.persistence = "Manual"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "man"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("manual")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("manual storage explanation")))])]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.preferences.useOffline) ? _c('div', {
    staticClass: "margin-son"
  }, [_c('div', {
    staticClass: "radio-title"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("synchronization")))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("synchronization explanation")))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "margin-self"
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "sincroRadio"
      }
    },
    model: {
      value: (_vm.preferences.sincro),
      callback: function($$v) {
        _vm.preferences.sincro = $$v
      },
      expression: "preferences.sincro"
    }
  }, [(_vm.disabled.sincro_Disabled != true) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.sincro),
      expression: "preferences.sincro"
    }],
    attrs: {
      "name": "sync",
      "type": "radio",
      "id": "dis",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.preferences.sincro, "Disabled")
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        _vm.preferences.sincro = "Disabled"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("disabled")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("disabled explanation")))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.disabled.sincro_Manual != true) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.sincro),
      expression: "preferences.sincro"
    }],
    attrs: {
      "name": "sync",
      "type": "radio",
      "id": "sman",
      "value": "Manual"
    },
    domProps: {
      "checked": _vm._q(_vm.preferences.sincro, "Manual")
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        _vm.preferences.sincro = "Manual"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sman"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("manual")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("manual sync explanation")))])]) : _vm._e(), _vm._v(" "), (_vm.preferences.sincro == 'Manual') ? _c('div', {
    staticClass: "margin-son"
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "syncBellCheck"
      }
    },
    model: {
      value: (_vm.preferences.manualSyncBell),
      callback: function($$v) {
        _vm.preferences.manualSyncBell = $$v
      },
      expression: "preferences.manualSyncBell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.manualSyncBell),
      expression: "preferences.manualSyncBell"
    }],
    attrs: {
      "id": "syncBell",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.preferences.manualSyncBell) ? _vm._i(_vm.preferences.manualSyncBell, null) > -1 : (_vm.preferences.manualSyncBell)
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        var $$a = _vm.preferences.manualSyncBell,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.preferences.manualSyncBell = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.preferences.manualSyncBell = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.preferences.manualSyncBell = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "syncBell"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("appropriate sync")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("appropriate sync explanation")))])])], 1) : _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.sincro),
      expression: "preferences.sincro"
    }],
    attrs: {
      "name": "sync",
      "type": "radio",
      "id": "insta",
      "value": "Instant"
    },
    domProps: {
      "checked": _vm._q(_vm.preferences.sincro, "Instant")
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        _vm.preferences.sincro = "Instant"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "insta"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("immediate")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("immediate explanation")))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.sincro),
      expression: "preferences.sincro"
    }],
    attrs: {
      "name": "sync",
      "type": "radio",
      "id": "def",
      "value": "Deferred"
    },
    domProps: {
      "checked": _vm._q(_vm.preferences.sincro, "Deferred")
    },
    on: {
      "change": _vm.contentChange,
      "__c": function($event) {
        _vm.preferences.sincro = "Deferred"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "def"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("deferred")))]), _vm._v(" "), _c('p', {
    staticClass: "desc-label"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("deferred explanation")))])]), _vm._v(" "), (_vm.preferences.sincro == 'Deferred') ? _c('div', {
    staticClass: "margin-son"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "3px"
    }
  }, [_c('input-w', {
    attrs: {
      "configs": {
        "id": "defIntMin"
      }
    },
    model: {
      value: (_vm.preferences.deferredInterval),
      callback: function($$v) {
        _vm.preferences.deferredInterval = $$v
      },
      expression: "preferences.deferredInterval"
    }
  }, [_c('label', {
    staticClass: "col-xs-4 col-md-3 sublabel",
    attrs: {
      "for": "defInt"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("interval")))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.deferredInterval),
      expression: "preferences.deferredInterval"
    }],
    attrs: {
      "id": "defInt",
      "type": "number"
    },
    domProps: {
      "value": (_vm.preferences.deferredInterval)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preferences.deferredInterval = $event.target.value
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$Jed.firstUpperTranslate("min.")) + "\r\n                                                "), _c('p', {
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("interval explanation")))])])])], 1)]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-info",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("restore predefined configs")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("save")))])], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd06d78","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Preferences.vue
// module id = 1727
// module chunks = 1